<template>
  <div>
    <b-row
      align-v="center"
      align-h="end"
    >
      <b-col
        xl="5"
        md="12"
      >
        <h6>Dari</h6>
        <b-row
          align-v="center"
          align-h="center"
          no-gutters
        >
          <b-col cols="6">
            <v-select
              v-model="data.startMonth"
              :options="monthsOptions"
              :reduce="val => val.value"
              :searchable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :selectable="(option) => data.startYear === currentYear ? option.value <= currentMonth : option"
            />
          </b-col>
          <b-col
            cols="6"
            class="pl-1"
          >
            <v-select
              v-model="data.startYear"
              :options="yearOptions"
              :reduce="val => val.value"
              :searchable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        xl="auto"
        md="12"
        class="p-0"
      >
        <feather-icon
          size="18"
          icon="MinusIcon"
          class="mt-2 d-none d-md-block"
        />
        <div class="mt-2 d-block d-md-none" />
      </b-col>
      <b-col
        xl="5"
        md="12"
      >
        <h6>Sampai</h6>
        <b-row
          align-v="center"
          align-h="center"
          no-gutters
        >
          <b-col
            cols="6"
          >
            <v-select
              v-model="data.endMonth"
              :options="monthsOptions"
              :reduce="val => val.value"
              :searchable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :selectable="(option) => data.endYear === currentYear ? option.value <= currentMonth : option"
            />
          </b-col>
          <b-col
            cols="6"
            class="pl-1"
          >
            <v-select
              v-model="data.endYear"
              :options="yearOptions"
              :reduce="val => val.value"
              :searchable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    vSelect,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('dashboard', ['monthsOptions']),
    yearOptions() {
      const currentyear = new Date().getFullYear()

      return [
        { label: currentyear, value: currentyear },
        { label: currentyear - 1, value: currentyear - 1 },
      ]
    },
    currentMonth() {
      const now = new Date()
      return now.getMonth() === 12 ? 1 : now.getMonth() + 1
    },
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
